export default {
      id: "login-li-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "sprite-46b249.svg#login-li-usage",
      toString: function () {
        return this.url;
      }
    }